import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDownloadIconSecondary from './svgs/DownloadIconSecondary.js';
import SvgDownloadIcon from './svgs/DownloadIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var downloadIcon = (props => useIcon(SvgDownloadIcon, SvgDownloadIconSecondary, props));

export { downloadIcon as default };
